import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { usersBusiness } from "api/bussiness/user-role-permission/users-bussiness";
import { UserPermission } from "commons/enum/permission";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IUserProperties } from "mobx-stores/_models/user-roles/user";
import { useCallback, useEffect } from "react";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { useStores } from "../../../../mobx-stores/_root-store";
import { StatusChip } from "../../../../share-components/atomics/status-chip";
import { XTablePagination } from "../../../../share-components/mui-wrap/table/x-table-pagination";
export const UserList = observer(() => {
  const {
    userManagement: { users, getUsers, pagination, setProp, userSelected },
    deleteConfirmationStore,
  } = useStores();

  useEffect(() => {
    getUsers({
      filter: pagination.filter,
      maxResultCount: pagination.itemsPerPage,
      skipCount: pagination.skipCount,
      sorting: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditBtnClickHandler = useCallback(
    (user: IUserProperties) => {
      setProp("openEdit", true);
      setProp("userSelected", cloneDeep(user));
    },
    [setProp]
  );

  const onDelete = useCallback(
    async (user: IUserProperties) => {
      if (user && user.id) {
        await usersBusiness.deleteUser(user?.id);

        getUsers({
          filter: pagination.filter,
          maxResultCount: pagination.itemsPerPage,
          skipCount: pagination.skipCount,
          sorting: "",
        });
      }
    },
    [getUsers, pagination.filter, pagination.itemsPerPage, pagination.skipCount]
  );

  const onDeleteBtnClickHandler = useCallback(
    (user: IUserProperties) => {
      setProp("userSelected", cloneDeep(user));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(user);
      });
    },
    [deleteConfirmationStore, onDelete, setProp]
  );

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getUsers({
        filter: pagination.filter,
        maxResultCount: pagination.itemsPerPage,
        skipCount: pagination.skipCount,
        sorting: "",
      });
    },
    [getUsers, pagination]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Tên đăng nhập</TableCell>
          <TableCell>Tên người dùng</TableCell>
          <TableCell>Trạng thái</TableCell>
          <TableCell>Email</TableCell>
          <TableCell>Điện thoại</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {users.map((x, i) => (
          <TableRow
            onClick={() => {
              setProp("userSelected", cloneDeep(x));
            }}
            data-id={x.id}
            key={x.id}
            hover
            sx={{
              cursor: "pointer",
              height: "55px",
            }}
            selected={x.id === userSelected?.id}
          >
            <TableCell width={"30%"}>{x.userName || ""}</TableCell>
            <TableCell>{x.name}</TableCell>
            <TableCell>
              <StatusChip
                status={x.isActive ? "active" : "deactivated"}
              ></StatusChip>
            </TableCell>
            <TableCell>{x.email}</TableCell>
            <TableCell>{x.phoneNumber}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[UserPermission.Update]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[UserPermission.Delete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
